export default "__VITE_ASSET__CPPMFBmR__"